import Atmosphere from './components/Atmosphere.jsx';
import Nav from './components/Nav.jsx';
import Footer from './components/Footer.jsx';
import LandingPage from './pages/LandingPage.jsx';

/* <App />
   ----------------------------------------------------------
   Single-page site. "Book walkthrough demo" CTAs link out to
   Calendly directly (see <DemoCTA>), so there's no in-page
   modal to mount. */
export default function App() {
  return (
    <>
      <Atmosphere />
      <Nav />
      <main>
        <LandingPage />
      </main>
      <Footer />
    </>
  );
}
